import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DateTimeField from '../../bootstrap-datetimepicker';
import DateUtils from '../../../utils/DateUtils';
import moment from 'moment';
import config from '../../../config';
import StringConstant from '../../../constants/StringConstants';
import ValidationConfig from '../../../config/ValidationConfig';
import RegexUtils from '../../../utils/RegexUtils';
import { hasExceededYouthAccountPaymentLimit } from '../../../utils/AccountUtils';

class EditSinglePayment extends React.Component {
  constructor(props) {
    super(props);
    this.editSinglePayment = this.editSinglePayment.bind(this);
    this.amountChange = this.amountChange.bind(this);
    this.referenceChange = this.referenceChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.updateFormValidation = this.updateFormValidation.bind(this);
    this.isGroupValid = this.isGroupValid.bind(this);
    this.checkOnBlurFeildValid = this.checkOnBlurFeildValid.bind(this);
    this.onblur = this.onblur.bind(this);
    this.onRefBlur = this.onRefBlur.bind(this);
    this.onDateBlur = this.onDateBlur.bind(this);
    const futureDate = moment(
      DateUtils.getMomentFromDateString(this.props.activeData.when)
    ).format(config.dateFormatSlash);
    this.state = {
      amount: parseFloat(this.props.activeData.amount).toFixed(2),
      reference: this.props.activeData.reference,
      futureDate,
      isContinueDisabled: this.props.isContinueDisabled,
      formGroup: [
        {
          futureDate: {
            isValid: ValidationConfig.isAfter(futureDate, moment()),
            isChanged: false,
          },
        },
      ],
      fieldBlurred: {
        amount: false,
        reference: false,
        futureDate: false,
      },
    };
  }
  onblur(e) {
    const name = e.target.name;
    this.state.fieldBlurred[name] = true;
    this.checkOnBlurFeildValid(name);
  }
  onDateBlur() {
    this.state.fieldBlurred['futureDate'] = true;
    this.checkOnBlurFeildValid('futureDate');
  }
  checkOnBlurFeildValid(name) {
    const formIndex = _.findIndex(this.state.formGroup, name);
    if (formIndex >= 0) {
      if (!this.state.formGroup[formIndex][name].isValid) {
        this.showError(name, true);
      } else {
        this.showError(name, false);
      }
    }
  }

  onDateChange(e) {
    const validationResult = ValidationConfig.validateDate(e);
    if (validationResult) {
      const dateIsLessThan = ValidationConfig.isBefore(
        e,
        moment().add(1, 'years')
      );
      const date = new Date();
      date.setDate(date.getDate() - 1);
      const isGretaterThanCurrentDate = ValidationConfig.isAfter(e, moment());
      if (isGretaterThanCurrentDate && dateIsLessThan) {
        this.updateFormValidation('futureDate', true, true);
        this.showError('futureDate', false);
      } else {
        this.updateFormValidation('futureDate', false, true);
        this.showError('futureDate', true);
      }
    } else {
      this.updateFormValidation('futureDate', false, true);
      this.showError('futureDate', true);
    }
    this.setState({
      futureDate: e,
    });
  }
  // to validate the amount
  amountChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const isInternalTransfer = this.props.activeData.isInternalPayment;
    // if previous value and changed value is same
    if (value === this.props.activeData.amount) {
      this.updateFormValidation(name, true, false);
      this.setState({
        amount: value,
      });
      return;
    }
    const validationResult = ValidationConfig.validateData(name, value);
    if (validationResult.isValid) {
      if (value.endsWith('.')) {
        this.setState({
          amount: value,
        });
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (value.length === 2 && value === '00') {
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (parseFloat(value) === 0.0) {
        this.setState({
          amount: value,
        });
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (
        !isInternalTransfer &&
        hasExceededYouthAccountPaymentLimit(value)
      ) {
        this.setState({
          amount: value,
        });
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (value <= 999999) {
        this.setState({
          amount: value,
        });
        this.showError(name, false);
        this.updateFormValidation(name, true, true);
      }
    } else {
      if (!validationResult.regexValid) {
        const length = value.length;
        if (length === 0) {
          this.setState({
            amount: e.target.value,
          });
          this.showError(name, true);
          this.updateFormValidation(name, false, true);
        } else if (isNaN(value) && length === 1) {
          this.updateFormValidation(name, false, true);
        } else if (value <= 999999) {
          this.updateFormValidation(name, true, true);
        }
      } else if (!validationResult.minLengthValid) {
        this.setState({
          amount: e.target.value,
        });
        this.updateFormValidation(name, false, true);
        this.showError(name, true);
      } else if (!validationResult.maxLengthValid) {
        if (parseFloat(value) !== 0.0) {
          this.updateFormValidation(name, true, true);
        }
      }
    }
  }
  showError(name, show) {
    if (this.state.fieldBlurred[name] && this.refs[`${name}Component`]) {
      if (show) {
        this.refs[`${name}Component`].classList.add('c-field--error');
      } else {
        this.refs[`${name}Component`].classList.remove('c-field--error');
      }
    }
  }
  updateFormValidation(name, isValid, isChanged) {
    const formIndex = _.findIndex(this.state.formGroup, name);
    if (formIndex >= 0) {
      this.state.formGroup[formIndex][name] = {
        isValid,
        isChanged,
      };
    } else {
      const formElement = {};
      formElement[name] = {
        isValid,
        isChanged,
      };
      this.state.formGroup.push(formElement);
    }
    if (this.state.isContinueDisabled) {
      this.setState({ isContinueDisabled: false });
    }
  }
  referenceChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const expression = RegexUtils.regexes.referenceRegex;
    const actualValue = value.match(expression)[0];
    if (this.props.activeData.payType === 'Payment') {
      if (actualValue.trim().length === 0) {
        this.updateFormValidation(name, false, true);
        this.showError(name, true);
      } else {
        this.updateFormValidation(name, true, true);
        this.showError(name, false);
      }
    } else {
      this.updateFormValidation(name, true, true);
    }
    this.setState({
      reference: actualValue,
    });
  }

  onRefBlur(e) {
    const name = e.target.name;
    if (this.props.activeData.payType === 'Payment') {
      this.state.fieldBlurred[name] = true;
      this.checkOnBlurFeildValid(name);
    }
    this.setState({
      reference: e.target.value.trim(),
    });
    // TO DO Check weather it is valid or not if no Show error message
  }
  isGroupValid() {
    let isGroupValid = true;
    let isChangedCounter = 0;
    _.every(this.state.formGroup, (item) => {
      const key = Object.keys(item)[0];
      if (item[key].isValid) {
        if (item[key].isChanged) {
          isChangedCounter++;
        }
      } else {
        this.refs[`${key}Component`].classList.toggle('c-field--error', true);
        isGroupValid = false;
        isChangedCounter = 1;
      }
      return true;
    });
    if (isChangedCounter === 0) {
      return false;
    }
    return isGroupValid;
  }
  editSingleData() {
    return (
      <div className="c-field c-field--datepicker" ref="futureDateComponent">
        <label
          className="c-field__label c-field__label--block"
          htmlFor="fdpdate"
        >
          Date
        </label>
        <div className="c-field__controls">
          <div className="c-field__append">
            <div className="pos-r">
              <DateTimeField
                defaultText={this.state.futureDate || ''}
                dateTime={this.state.futureDate || DateUtils.getShortString1()}
                format={config.dateFormatSlash}
                inputFormat={config.dateFormatSlash}
                onChange={this.onDateChange}
                viewMode="days"
                minDate={moment().add(1, 'day')}
                maxDate={moment().add(1, 'years')}
                inputProps={{
                  title: `${this.props.children} : ${config.dateFormatSlash}`,
                  placeholder: config.dateFormatSlash,
                  id: this.props.name,
                  onBlur: this.onDateBlur,
                  'aria-live': 'futureDateErr',
                  'aria-invalid': 'false',
                  'aria-required': 'true',
                }}
              />
            </div>
          </div>
          <div
            className="c-field__message"
            ref="futureDateMessage"
            role="alert"
            id="futureDateErr"
          >
            <p>{this.props.content.futureDateErrorMessage}</p>
          </div>
        </div>
      </div>
    );
  }
  editSinglePayment() {
    if (
      this.isGroupValid() ||
      (!this.props.isContinueDisabled && this.state.formGroup.length === 0)
    ) {
      const activeData = this.props.activeData;
      activeData.reference = this.state.reference.trim();
      activeData.amount = parseFloat(this.state.amount);
      activeData.when = DateUtils.getAPIDateString(this.state.futureDate);
      this.props.editSinglePayment(activeData);
    }
  }
  render() {
    const { isSMEUser } = this.props;
    return (
      <div>
        <div className="c-field" ref="amountComponent">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="fapp1"
          >
            Amount
          </label>
          <div className="c-field__controls">
            <div className="c-field__prepend">
              <span className="c-field__addon" aria-hidden="true">
                &pound;
              </span>
              <input
                aria-label="Amount in pounds and pence"
                aria-invalid="false"
                aria-required="true"
                className="c-field__input"
                type="text"
                name="amount"
                id="fapp1"
                value={this.state.amount}
                onChange={this.amountChange}
                onBlur={this.onblur}
              />
            </div>
            <div
              className="c-field__message"
              ref="amountMessage"
              role="alert"
              id="amountErr"
            >
              <p>
                {hasExceededYouthAccountPaymentLimit(this.state.amount)
                  ? this.props.content.youthAccountAmountExceededMessage
                  : this.props.content.amountErrorMessage}
              </p>
            </div>
          </div>
        </div>
        <div className="c-field c-field--disabled" ref="referenceComponent">
          <label
            className="c-field__label c-field__label--black c-field__label--block"
            htmlFor="f1"
          >
            {this.props.content.reference}&nbsp;
            {this.props.activeData.payType === 'Transfer' ? (
              <span className="c-field__option">(optional)</span>
            ) : null}
          </label>
          <div className="c-field__controls">
            <input
              aria-invalid="false"
              aria-required="true"
              className="c-field__input"
              value={this.state.reference}
              type="text"
              ref="reference"
              name="reference"
              id="f1"
              onChange={this.referenceChange}
              onBlur={this.onRefBlur}
              disabled
            />
            <div
              className="c-field__message"
              ref="referenceMessage"
              role="alert"
              id="referenceErr"
            >
              <p>{this.props.content.refErrorMsgManagePayments}</p>
            </div>
          </div>
        </div>
        {this.editSingleData()}
        <div className="c-field">
          <button
            onClick={this.props.goBack}
            className="c-btn c-btn--secondary"
          >
            {StringConstant.back}
          </button>
          &nbsp;
          <button
            className="c-btn c-btn--default"
            onClick={this.editSinglePayment}
            disabled={this.state.isContinueDisabled}
          >
            {isSMEUser
              ? StringConstant.continue
              : StringConstant.confirmChanges}
          </button>
        </div>
      </div>
    );
  }
}

EditSinglePayment.propTypes = {
  isSMEUser: PropTypes.bool,
};
export default EditSinglePayment;
